import css from "./ProductChk.module.css";
import "./ProductChk.css"

import { useRef, useState } from "react";
import { regUses, usePdts, useRcd, useRcds, useTbl } from "../../axios_with_token";
import { useRcdList } from "../../input_types/Tbl/Tbl";
import { useDialog, useRcdEditDialog } from "../../input_types/Dialog/Dialog";
import { Warehouse } from "@mui/icons-material";

export function PdtCatSelector(catId, setCatId){
    const {regUse, DefaultResponse} = regUses();
    return <DefaultResponse>
            <div className="input-group">
                <span className="input-group-text">Category</span>
                <select
                    className="form-control form-control-sm"
                    defaultValue={catId}
                    onChange={evt=>{
                        // setTimeout(_=>setChkId(evt.target.value), 10);
                    }}
                    role="chk"
                >
                    <option
                        key={0}
                        value={0}
                    ></option>
                    {/* {((tblInventoryChecks||{}).rcds||[]).map((rcd, idx)=><option
                        key={rcd.__id}
                        value={rcd.__id}
                    >
                        {rcd.date} / {rcd.sn}
                    </option>)} */}
                </select>
                <button className="btn btn-sm btn-outline-secondary" type="button"
                    onClick={evt=>{
                        // // [] for RcdEditDialog
                        // // setTblName('inventoryChecks');
                        // setEditNewRcdId(false);
                        // openEditNewDlg();
                    }}
                >+</button>
                <button className="btn btn-sm btn-outline-secondary" type="button"
                    onClick={evt=>{
                        // // [] for RcdEditDialog
                        // // setTblName('inventoryChecks');
                        // setEditNewRcdId(chkId);
                        // openEditNewDlg();
                    }}
                >E</button>
                <button className="btn btn-sm btn-outline-secondary" type="button"
                    onClick={evt=>{
                        // openDlgInvCheckInfoDlg();
                    }}
                >i</button>
                <button className="btn btn-sm btn-outline-secondary" type="button"
                    onClick={evt=>{
                        // setChkId(0);
                    }}
                >X</button>
            </div>
    </DefaultResponse>
}

export default function ProductChk({}){
    const {regUse, DefaultResponse} = regUses();

    const getFilter = _=>{
        const filter = {};

        return filter;
    }

    const {
        invalidate,
        setActiveRcdId,
        Component: PdtList,
        setListType
    } = regUse(useRcdList({
        tblName: 'pdts', 
        // page, 
        rcdsPerPage: 9999, 
        filter: getFilter(),
        reset: JSON.stringify(getFilter()),
        // showIndex, 
        // btns, listFlds:listFldsIn, 
        listType:'cards',
        dataFlds: '__id,skidId',
        hidePagination: true,
        hideSearch: true,
        hideListTypeSelector: true,
        // CompList: ()=><h5>list item</h5>,

        onItemClick: ({tblName, rcdId, evt, rcd})=>{
            // console.log('{tblName, __id, evt}:', tblName, rcdId, evt, rcd);
            // setPosId(rcdId);
            // openDlgPosInfoDlg();
        },
        btns: {
            edit: ({rcdId, cb})=><button type="button"
                className="btn btn-sm btn-sm btn-primary"
                onClick={evt=>{
                    // // evt.stopPropagation();
                    // // setTblName('poses');
                    // // [] for RcdEditDialog
                    // setPosId(rcdId);
                    // // [] for list
                    // cb&&cb();
                    // openDlgPosInfoDlg();
                }}
            >edit</button>,
        }

        // CompList
    }));

    return <DefaultResponse>
        <PdtCatSelector></PdtCatSelector>
        <h1>ProductChk</h1>
        <PdtList></PdtList>
    </DefaultResponse>
}

